import FormDataPreview from "../../Formular/FormDataPreview";
import { timeDivisions } from "components/TrainingPlan/TrainingPlanHelpers";
import moment from "moment";
import React from "react";
import styled from "styled-components";
import { SpaceBooking } from "../types";

interface Props {
    booking: SpaceBooking;
}

const StyledSpaceBookingPreview = styled.div`
    padding: 0.75rem;
    margin-bottom: 1rem;
    border-radius: ${({ theme }) => theme.borderRadius};
    background-color: ${({ theme }) => theme.colors.secondary};
    color: ${({ theme }) => theme.colors.white};
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: 0.25rem 2rem;

    > .header {
        font-weight: bold;
    }
`;

export const SpaceBookingPreview = ({ booking }: Props) => {
    return (
        <div>
            <StyledSpaceBookingPreview>
                <span className="header">Name</span>
                <span>{booking.user_name}</span>
                <span className="header">Datum</span>
                <span>{moment(booking.start).format("LL")}</span>
                <span className="header">Uhrzeit</span>
                <span>
                    {timeDivisions.times[booking.start_time]} bis {timeDivisions.times[booking.end_time]}
                </span>
                <span className="header">Stornierbar bis</span>
                <span>{moment(booking.cancelable_until).format("LLL")}</span>
                <span className="header">Plätze</span>
                <span>{booking.spaces?.map((space) => space.name).join(", ")}</span>
                <span className="header">Mitspieler</span>
                <span>{booking.fellows?.map((fellow) => fellow.name).join(", ")}</span>
                {booking.subscription.title && (
                    <>
                        <span className="header">Abo</span>
                        <span>{booking.subscription.title}</span>
                    </>
                )}
                {booking.voucher && (
                    <>
                        <span className="header">Karte</span>
                        <span>
                            #{booking.voucher.id} | {booking.voucher.units_used}
                        </span>
                    </>
                )}
            </StyledSpaceBookingPreview>
            {booking.form_data_id && <FormDataPreview formDataId={booking.form_data_id} />}
        </div>
    );
};
